define('app/store',['require','glu/store'],function(require) {
	'use strict';

	var sessionStore = require('glu/store');

	var API_TOKEN = 'API-TOKEN';
	var API_USERNAME = 'API-USERNAME';

	return {
		getApiToken: function() {
			return sessionStore.get(API_TOKEN);
		},

		setApiToken: function(token) {
			if (token) {
				sessionStore.set(API_TOKEN, token);
			} else {
				sessionStore.unset(API_TOKEN);
			}
		},

		getApiUsername: function() {
			return sessionStore.get(API_USERNAME);
		},

		setApiUsername: function(username) {
			if (username) {
				sessionStore.set(API_USERNAME, username);
			} else {
				sessionStore.unset(API_USERNAME);
			}
		}
	};
});

